import { useSanctumConfig } from "../../composables/useSanctumConfig.js";
import { useSanctumUser } from "../../composables/useSanctumUser.js";
import { navigateTo } from "#app";
export async function handleResponseError(nuxtApp, context, logger) {
  const options = useSanctumConfig();
  const user = useSanctumUser();
  const response = context.response;
  if (response.status === 419) {
    logger.warn("CSRF token mismatch, check your API configuration");
    return;
  }
  if (response.status === 401) {
    if (user.value !== null) {
      logger.warn("User session is not set in API or expired, resetting identity");
      user.value = null;
    }
    if (import.meta.client && options.redirectIfUnauthenticated && options.redirect.onAuthOnly) {
      const redirectUrl = options.redirect.onAuthOnly;
      await nuxtApp.callHook("sanctum:redirect", redirectUrl);
      await nuxtApp.runWithContext(async () => await navigateTo(redirectUrl));
    }
  }
}
